<script>
  import {_} from 'svelte-i18n';
  import {link, location} from 'svelte-spa-router';
  import {api, cutText, getVideo} from '../../../helpers/index.js';
  import {groups, info_client} from '../../stores.js';
  import PreviewCardTopPanel from './components/PreviewCardTopPanel.svelte';
  import Likes from '../Likes.svelte';
  import ToggleVideoButton from '../ToggleVideoButton.svelte';

  // Модель публикации
  export let publication;

  // Закреплена ли публикация
  export let fixPublication = undefined;

  let publicationBorderColor;

  $: publicationBorderColor = fixPublication
    ? $groups.find(group => group.slug === publication.feed_group.slug)?.color
    : '#F3F3F4'

  const {
    id,
    title,
    files,
    audios,
    feed_tags,
    preview_text,
    preview_image,
    pub_start_date,
    additional_content,
  } = publication;

  const youtubeVideoKey = 'youtube';
  const kinescopeVideoKey = 'kinescope';

  let isShowVideo = false;
  let currentShowVideo = null;
  let videoType = currentShowVideo?.video_domain ? youtubeVideoKey : kinescopeVideoKey;

  const clickedLog = async (file) => {
    if (!file.doc_url.toLowerCase().includes('summary')) {
      return
    }

    const path = '/api/v1/logging/publication/create/click-file/'
    const method = 'POST'
    const isJSON = true
    const body = JSON.stringify({ publication: +id, publication_item: +file.pk })

    await api(path, method, body, isJSON)
  }

  const showVideos = (video) => {
    currentShowVideo = null;
    isShowVideo = true;
    currentShowVideo = video;
    videoType = currentShowVideo?.video_domain ? youtubeVideoKey : kinescopeVideoKey;
    clickedLogVideo(video.pk);
  }

  const clickedLogVideo = async (pk) => {
    const path = '/api/v1/logging/publication/create/click-video/'
    const method = 'POST'
    const body = JSON.stringify({ publication: id, publication_item: pk })
    const isJSON = true

    await api(path, method, body, isJSON)
  }

  const viewPublication = async () => {
    const urlMethod = currentShowVideo.is_view ? 'delete' : 'create'
    const method = currentShowVideo.is_view ? 'DELETE' : 'POST'
    const url = `/api/v1/view-publication-item/${urlMethod}/${currentShowVideo.pk}/`

    await api(url, method, {}, false)

    currentShowVideo.is_view = !currentShowVideo.is_view;

    if (publication.videos.length === 1) {
      publication.i_view = publication.i_view === 100 ? 0 : 100;
    }

    if (publication.videos.length > 1) {
      publication.i_view = publication.videos.filter((item) => item.is_view).length / publication.videos.length * 100;
    }

    publication = publication;
  }
</script>

<div
  id={id}
  class="publication"
  style="border: 2px solid {publicationBorderColor}"
  class:fix-publication={fixPublication}
>
  <div class="main">
    <a 
      href={`/publicate/${id}?prev_url=${$location}`}
      use:link
    >
      <div class="main__item" >
        <div class="main__textpic">
          <div class="item__text text-grey">
            <PreviewCardTopPanel
              {fixPublication}
              {feed_tags}
              {additional_content}
              pub_start_date={$info_client?.flow?.is_green ? null : pub_start_date}
            />

            <span class="title text-bold">{title}</span>
            
            <span class="text">
              {preview_text} 
              <br />
              <span class="link">{$_('ReadMore')}</span>
            </span>
          </div>

          {#if !publication.videos.length}
            {#if preview_image}
              <div class="pic">
                <img src={preview_image} alt loading="lazy">
              </div>
            {/if}
          {:else} 
            <div class="pic" style={'display:none'}></div>
          {/if}
        </div>
      </div>
    </a>

    {#if publication.videos.length}
      <div class="videos videos-length-{publication.videos.length}">
        {#each publication.videos as video, index (index)}
          <div
            class="video"
            style:background={`url("${video.video_thumbnail}") no-repeat center/cover`}
            on:click|stopPropagation={() => showVideos(video)}
          >
            {#if !$info_client.is_staff && publication.is_show_view_button}
              <div class="icon-wrapper">
                <i  
                  class:icon-close-eye={!video.is_view}
                  class:icon-open-eye={video.is_view}
                  style:color={video.is_view ? '#2B50ED' : '#BDBFC4'}
                />
              </div>
            {/if}
          </div>
        {/each}
      </div>
    {/if}

    {#if audios.length}
      <div class="audio">
        {#each audios as audio}
          <div data-item-id={audio.pk} data-publ-id={id}>
            {@html audio.audio_url}
          </div>
        {/each}
      </div>
    {/if}

    {#if files.length}
      {#each files as file}
        <div class="main__dog">
          <div class="main__doc__text">
            <a 
              class="link__doc text-bold" 
              href={file.doc_url} 
              target="_blank"
              on:click|stopPropagation={() => clickedLog(file)}
            >
              <i class="icon-file" />
              <span class="title__doc">{ cutText(file.doc_url.split('/').slice(-1).join()) }</span>
            </a>
          </div>
        </div>
      {/each}
    {/if}  

    <div class="line"></div>
  </div>
  
  <div class="likes">
    <Likes data={publication} hideLikesAndComments={$info_client?.flow?.is_green} />
  </div>
</div>

{#if isShowVideo}
  <div class="video-preview-modal">
    <div class="modal-content">
      <i class="icon-cross" on:click={() => isShowVideo = false} />

      <div class="main-video">
        {#key currentShowVideo.video_url}
          <div class="current-video">
            <iframe 
              src={videoType === kinescopeVideoKey ? currentShowVideo.video_url_2 : getVideo(currentShowVideo.video_domain, currentShowVideo.video_url, true)} 
              referrerpolicy="strict-origin-when-cross-origin"
              allow="autoplay"
              title 
              allowfullscreen
              loading="lazy"
              class="is-not-staff"
            />
          </div>
        {/key}

        
        <div class="view-wrapper">
          <div class="buttons-wrapper flex items-center w-full">
            <div class="flex items-center gap-2">
              {#if currentShowVideo.video_url}
                <ToggleVideoButton 
                  label={youtubeVideoKey}
                  isActive={videoType === youtubeVideoKey}
                  on:toggle={() => videoType = youtubeVideoKey}
                />
              {/if}

              {#if currentShowVideo.video_url_2}
                <ToggleVideoButton 
                  label={kinescopeVideoKey}
                  isActive={videoType === kinescopeVideoKey}
                  on:toggle={() => videoType = kinescopeVideoKey}
                />
              {/if}
            </div>

            {#if !$info_client.is_staff && publication.is_show_view_button}
              <div class="text">{$_('seenVideoReminder')}</div>
            {/if}
          </div>
          
          {#if !$info_client.is_staff && publication.is_show_view_button}
            <button 
              type="button"
              class="view-button"
              class:active={currentShowVideo.is_view}
              on:click={viewPublication}
            >
              {#if currentShowVideo.is_view}
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3462 7.7602C13.0538 4.9462 10.6227 3.2002 7.99961 3.2002C5.37652 3.2002 2.94537 4.9462 1.65302 7.7602C1.61779 7.8359 1.59961 7.9176 1.59961 8.0002C1.59961 8.08279 1.61779 8.1645 1.65302 8.2402C2.94537 11.0542 5.37652 12.8002 7.99961 12.8002C10.6227 12.8002 13.0538 11.0542 14.3462 8.2402C14.3814 8.1645 14.3996 8.08279 14.3996 8.0002C14.3996 7.9176 14.3814 7.8359 14.3462 7.7602ZM6.57785 6.00467C6.99869 5.74095 7.49347 5.6002 7.99961 5.6002C8.67833 5.6002 9.32925 5.85305 9.80918 6.30314C10.2891 6.75323 10.5587 7.36368 10.5587 8.0002C10.5587 8.47487 10.4086 8.93889 10.1274 9.33356C9.84624 9.72824 9.44656 10.0359 8.97894 10.2175C8.51133 10.3992 7.99677 10.4467 7.50036 10.3541C7.00394 10.2615 6.54795 10.0329 6.19005 9.69725C5.83215 9.36161 5.58842 8.93397 5.48968 8.46841C5.39093 8.00286 5.44161 7.5203 5.6353 7.08176C5.829 6.64321 6.15701 6.26838 6.57785 6.00467ZM7.99962 9.2002C7.74655 9.2002 7.49916 9.12982 7.28874 8.99796C7.07832 8.8661 6.91432 8.67869 6.81747 8.45942C6.72062 8.24014 6.69528 7.99887 6.74466 7.76609C6.79403 7.53331 6.91589 7.31949 7.09484 7.15167C7.27379 6.98385 7.50179 6.86956 7.74999 6.82325C7.9982 6.77695 8.25548 6.80072 8.48929 6.89154C8.72309 6.98237 8.92293 7.13617 9.06353 7.33351C9.20413 7.53085 9.27918 7.76286 9.27918 8.0002C9.27918 8.31846 9.14437 8.62368 8.9044 8.84872C8.66444 9.07377 8.33898 9.2002 7.99962 9.2002Z" fill="#2B50ED"/>
                </svg>
              {:else}
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4564 7.97516L13.2632 7.19998L14.4564 6.42479L15 7.19997L14.4564 7.97516ZM2.73677 7.19998C1.54363 7.97516 1.54394 7.97561 1.54426 7.97606L1.54494 7.97703L1.54644 7.97916L1.55001 7.98421L1.55944 7.99737C1.56673 8.0075 1.57604 8.0203 1.58737 8.03559C1.61 8.06617 1.64071 8.1068 1.67935 8.15604C1.75653 8.25438 1.86595 8.38785 2.00649 8.54469C2.28617 8.8568 2.69682 9.27014 3.23006 9.68489C4.28671 10.5067 5.91326 11.4 8.00003 11.4C10.0868 11.4 11.7133 10.5067 12.7699 9.68488C13.3032 9.27013 13.7138 8.8568 13.9935 8.54468C14.134 8.38785 14.2435 8.25438 14.3206 8.15604C14.3593 8.1068 14.39 8.06617 14.4126 8.03559C14.4239 8.0203 14.4333 8.0075 14.4406 7.99737L14.45 7.98421L14.4535 7.97916L14.4557 7.97606C14.456 7.97561 14.4564 7.97516 13.2632 7.19998C14.4564 6.42479 14.456 6.42434 14.4557 6.42389L14.4535 6.42079L14.45 6.41574L14.4405 6.40258C14.4333 6.39245 14.4239 6.37965 14.4126 6.36436C14.39 6.33378 14.3593 6.29315 14.3206 6.24392C14.2435 6.14557 14.134 6.01211 13.9935 5.85527C13.7138 5.54316 13.3032 5.12983 12.7699 4.71509C11.7133 3.89324 10.0868 3 8.00003 3C5.91326 3 4.28672 3.89323 3.23006 4.71508C2.69683 5.12983 2.28618 5.54316 2.0065 5.85527C1.86596 6.0121 1.75653 6.14557 1.67935 6.24391C1.64072 6.29315 1.61001 6.33378 1.58737 6.36436C1.57605 6.37965 1.56673 6.39245 1.55944 6.40258L1.55002 6.41574L1.54644 6.42079L1.54494 6.42292L1.54426 6.42389C1.54394 6.42434 1.54363 6.42479 2.73677 7.19998ZM2.73677 7.19998L1.54363 7.97516L1 7.19997L1.54363 6.42479L2.73677 7.19998ZM2.73677 7.19998C2.73677 7.19998 4.71049 4.38557 8.00003 4.38557C11.2895 4.38557 13.2632 7.19998 13.2632 7.19998C13.2632 7.19998 11.2895 10.0144 8.00003 10.0144C4.71049 10.0144 2.73677 7.19998 2.73677 7.19998Z" fill="#BDBFC4"/>
                  <path d="M7.4748 11.2248C7.4748 10.9107 7.72943 10.656 8.04355 10.656C8.35766 10.656 8.6123 10.9107 8.6123 11.2248V13.281C8.6123 13.5951 8.35766 13.8498 8.04355 13.8498C7.72943 13.8498 7.4748 13.5951 7.4748 13.281V11.2248Z" fill="#BDBFC4"/>
                  <path d="M4.99166 10.4478C5.14871 10.1758 5.49656 10.0826 5.76858 10.2397C6.04061 10.3967 6.13382 10.7446 5.97676 11.0166L4.92646 12.5625C4.7694 12.8345 4.42156 12.9278 4.14953 12.7707C3.8775 12.6136 3.7843 12.2658 3.94136 11.9938L4.99166 10.4478Z" fill="#BDBFC4"/>
                  <path d="M2.43751 8.36172C2.61768 8.10441 2.97232 8.04188 3.22962 8.22205C3.48693 8.40221 3.54946 8.75686 3.36929 9.01416L2.49172 10.1263C2.31155 10.3836 1.95691 10.4461 1.69961 10.2659C1.4423 10.0858 1.37977 9.73113 1.55994 9.47383L2.43751 8.36172Z" fill="#BDBFC4"/>
                  <path d="M11.0956 10.4478C10.9385 10.1758 10.5907 10.0826 10.3187 10.2397C10.0466 10.3967 9.95342 10.7446 10.1105 11.0166L11.1898 12.5916C11.3469 12.8636 11.6947 12.9568 11.9668 12.7998C12.2388 12.6427 12.332 12.2949 12.1749 12.0228L11.0956 10.4478Z" fill="#BDBFC4"/>
                  <path d="M13.6496 8.36172C13.4694 8.10441 13.1148 8.04188 12.8575 8.22205C12.6002 8.40221 12.5376 8.75686 12.7178 9.01416L13.5074 10.0382C13.6876 10.2955 14.0422 10.358 14.2995 10.1778C14.5568 9.99767 14.6194 9.64303 14.4392 9.38572L13.6496 8.36172Z" fill="#BDBFC4"/>
                </svg>
              {/if}
              
              <span>{currentShowVideo.is_view ? $_('viewed') : $_('notViewed')}</span>
            </button>
          {/if}
        </div>
      </div>

      <div class="all-videos">
        <div class="heading">
          {$_('videoFromThePost')}
        </div>

        <div class="video-list">
          {#each publication.videos as video, index (index)}
            <div
              class="video-list__item"
              style:background={`url("${video.video_thumbnail}") no-repeat center/cover`}
              style:border-color={currentShowVideo.pk === video.pk ? '#576CED' : 'transparent'}
              on:click|stopPropagation={() => showVideos(video)}
            />
          {/each}
        </div>
      </div>
    </div>
  </div>
{/if}


<style lang="scss">
  .view-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px;
    margin-right: 0;
    box-sizing: border-box;

    .text {
      font-size: 12px;
      line-height: 18px;
      padding-right: 16px;
      margin-left: auto;
    }

    @media (max-width: 500px) {
      margin-right: 16px;

      .buttons-wrapper {
        flex-direction: column;
        align-items: start;
        grid-gap: 8px;
      }
    }
  }

  .view-button {
    background: #F3F3F4;
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #5A5F6D99;
    padding: 5px 10px;
    border-radius: 30px;
    border: none;
    display: flex;
    align-items: center;
    grid-gap: 4px;

    span {
      white-space: nowrap;

      @media (max-width: 500px) {
        display: none;
      }
    }

    &.active {
      background: #EFF1FD;
      color: #2B50ED;
    }
  }
  
  .video-preview-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #22252CE5;
    z-index: 99999999999999999;

    .modal-content {
      color: white;
      background-color: #22252C;
      max-width: 1320px;
      width: 100%;
      max-height: 647px;
      border-radius: 16px;
      display: grid;
      grid-template-columns: 1047px 1fr;
      position: relative;
      margin: 60px auto;

      .icon-cross {
        color: white;
        position: absolute;
        font-size: 16px;
        right: -30px;
        cursor: pointer;

        @media (max-width: 577px) {
          right: 10px;
          top: -30px;
        }  
      }

      @media (max-width: 577px) {
        grid-template-columns: 1fr;
        grid-template-rows: 286px 148px;
      }

      .main-video {
        display: flex;
        flex-direction: column;

        @media (max-width: 576px) {
          border-bottom: 1px solid #5A5F6D99;
        }

        .current-video {
          position: relative;
          width: 100%;
          height: 100%;

          iframe {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            border: none;
            border-top-left-radius: 16px;

            @media (max-width: 577px) {
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              border-top-left-radius: 16px;
              border-top-right-radius: 16px;
            }
          }
        }
      }

      .all-videos {
        padding: 16px;
        padding-bottom: 0;

        @media (max-width: 577px) {
          overflow-x: scroll;
          padding-bottom: 16px;
          padding-right: 0;
        }

        .heading {
          font-weight: 600;
        }

        .video-list {
          overflow-y: scroll;
          height: 540px;
          margin-top: 8px;

          @media (max-width: 577px) {
            height: 80px;
            display: flex;
            align-items: center;
            overflow-x: scroll;
          }

          .video-list__item {
            margin-bottom: 8px;
            height: 129px;
            cursor: pointer;
            border-radius: 8px;
            border: 2px solid transparent;
            box-sizing: border-box;

            &:last-child {
              margin-bottom: 16px;
            }

            @media (max-width: 577px) {
              flex: none;
              height: 80px;
              width: 141px;
              margin-bottom: 0;
              margin-right: 8px;

              &:last-child {
                margin-right: 16px;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }

  .videos {
    .video {
      border-radius: 4px;
      display: flex;
      justify-content: end;
      align-items: end;

      .icon-wrapper {
        background: #EFF1FD;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 8px;

        @media (max-width: 375px) {
          width: 10px;
          height: 10px;
        }

        @media (max-width: 500px) {
          width: 16px;
          height: 16px;
        }

        i {
          font-size: 10px;

          @media (max-width: 500px) {
            font-size: 8px;
          }

          &::before {
            margin: 0;
            width: auto;
          }
        }
      }
    }
  }

  .videos-length {
    &-1 {
      display: flex;

      .video {
        width: 100%;
        height: 428px;

        @media (max-width: 500px) {
          height: 162px;
        }
      }
    }

    &-2 {
      display: flex;
      grid-gap: 4px;

      .video {
        width: 50%;
        height: 213px;

        @media (max-width: 500px) {
          height: 80px;
        }
      }
    }

    &-3 {
      grid-gap: 4px;
      display: grid;

      grid-template-columns: 500px 1fr;
      grid-template-rows: repeat(2, 130px);

      @media (max-width: 500px) {
        grid-template-columns: 194px 1fr;
        grid-template-rows: repeat(2, 52px);
      }

      .video {
        &:first-child {
          grid-row: 1 / 3;
        }
      }
    }

    &-4 {
      grid-gap: 4px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 213px);

      @media (max-width: 500px) {
        grid-template-rows: repeat(2, 80px);
      }
    }

    &-5 {
      display: flex;
      flex-wrap: wrap;
      grid-gap: 4px;

      .video {
        &:first-child,
        &:nth-child(2) {
          flex-basis: calc(50% - 4px);
          height: 211px;

          @media (max-width: 500px) {
            height: 96px;
          }
        }

        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          height: 140px;
          flex-basis: calc(33.33% - 4px);

          @media (max-width: 500px) {
            height: 65px;
          }
        }
      }
    }

    &-6 {
      grid-gap: 4px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(2, 140px);

      @media (max-width: 500px) {
        grid-template-rows: repeat(2, 53px);
      }
    }

    &-7 {
      display: flex;
      flex-wrap: wrap;
      grid-gap: 4px;

      .video {
        &:first-child,
        &:nth-child(2) {
          flex-basis: calc(50% - 4px);
          height: 211px;

          @media (max-width: 500px) {
            height: 80px;
          }
        }

        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6),
        &:nth-child(7) {
          height: 82px;
          flex-basis: calc(20% - 4px);

          @media (max-width: 500px) {
            height: 30px;
          }
        }
      }
    }

    &-8 {
      display: flex;
      flex-wrap: wrap;
      grid-gap: 4px;

      .video {
        &:first-child,
        &:nth-child(2),
        &:nth-child(3) {
          flex-basis: calc(33.33% - 4px);
          height: 156px;
        }

        &:first-child,
        &:nth-child(2) {
          @media (max-width: 500px) {
            flex-basis: calc(50% - 4px);
            height: 80px;
          }
        }

        &:nth-child(3) {
          @media (max-width: 500px) {
            flex-basis: calc(33.33% - 4px);
            height: 53px;
          }
        }

        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6),
        &:nth-child(7),
        &:nth-child(8) {
          height: 92px;
          flex-basis: calc(20% - 4px);

          @media (max-width: 500px) {
            height: 53px;
            flex-basis: calc(33.33% - 4px);
          }
        }
      }
    }

    &-9 {
      grid-gap: 4px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(3, 156px);

      @media (max-width: 500px) {
        grid-template-rows: repeat(3, 53px);
      }
    }

    &-10 {
      display: flex;
      flex-wrap: wrap;
      grid-gap: 4px;

      .video {
        &:first-child,
        &:nth-child(2) {
          flex-basis: calc(50% - 4px);
          height: 237px;

          @media (max-width: 500px) {
            height: 80px;
          }
        }

        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6),
        &:nth-child(7),
        &:nth-child(8),
        &:nth-child(9),
        &:nth-child(10) {
          height: 112px;
          flex-basis: calc(25% - 4px);

          @media (max-width: 500px) {
            height: 40px;
          }
        }
      }
    }
  }

  .icon-file {
    font-size: 15px;
  }
  
  .publication {
    box-sizing: border-box;
    background-color: white;
    border-radius: 10px;
    cursor: pointer;
    padding: 0 20px 0 20px;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    @media (max-width: 576px) {
      width: 100%;
      border: none !important;
      position: relative;
      border-radius: 0;
      padding: 0;
      margin-bottom: 0;

      &::after {
        content: '';
        border-bottom: 8px solid rgba(243, 243, 244, 1) !important;
        position: absolute;
        height: 8px;
        bottom: 0;
        left: -18px;
        right: -18px;
      }
    }
  }

  .publication a {
    text-decoration: none;
  }

  .main{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .main__dog{
    display: flex;
    flex-direction: column;
  }

  /* для заголовка и превью текста */
  .main__textpic {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    @media (max-width: 576px) {
      flex-direction: column;
    }
  }
  .item__text{
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    width: 100%;

    @media (max-width: 576px) {
      &:first-child {
        margin-top: 0;
      }
    }
  }

  /* для картинки */
  .pic {
    border: none;
    border-radius: 10px;
    margin: 20px 0 0 20px;

    @media (max-width: 576px) {
      margin: 12px 0 0 0;
    }
  }  
  img {
    width: 272px;
    height: 178px;
    border-radius: 10px;

    @media (max-width: 576px) {
      width: 100%;
      height: auto;
    }
  }

  /* стиль текста и заголовка */
  .title {
    font-size: 16px;
    line-height: 23px;
    margin-bottom:5px;
  }
  .text {
    font-size: 14px;
    line-height: 20px;
  } 

  .line { 
    content: " ";
    background: #E0E8F6;
    width: 100%;
    height: 1px;
    float: left;
    margin: 16px 0 0;
  }

  /* для аудио */
  .audio{
    margin-top: 16px;
  }

  /* блок документов */
  .main__dog{
    display: flex;
    justify-content: space-between;
    align-items:center;
    margin: 14px 0 14px 0;
    flex-direction: row;

    @media (max-width: 576px) {
      margin: 10px 0 0 0;
    }
  }
  .link__doc{
    display: flex;
    align-items:center;
    font-style: normal;
    font-size: 12px;
    line-height: 14px;
    color: #2B50ED;
    fill: #2B50ED; 
    cursor: pointer;  
    text-decoration: none;
  }

  .title__doc{
    padding-left: 5px;
    word-break: break-all;

    @media (min-width: 320px) and (max-width: 1000px) {
      padding-right: 10px;
    }
  }

  .likes{
    margin: 20px 0 20px 0;
  }

  @media (min-width: 320px) and (max-width: 1000px) {
    .fix-publication {
      .main__textpic {
        flex-direction: column;
      }

      img {
        width: 100%;
        height: auto;
      }

      .pic {
        margin: 16px 0 0 0;
      }
    }
  }
</style>
  
